import { analyticsConfig } from "./config";

export const BUSINESS_EVENT_NAMES = Object.freeze([
  "signup",
  "login",
  "add_friend",
  "send_message",
  "view_game",
  "add_review",
  "session_log",
  "onboarding_started",
  "steam_connected",
  "first_session_created",
  "onboarding_completed",
]);

export const BUSINESS_EVENT_SCHEMA = Object.freeze({
  signup: {
    required: ["auth_method", "result"],
    optional: ["user_id", "has_mfa"],
  },
  login: {
    required: ["auth_method", "result"],
    optional: ["user_id", "has_mfa"],
  },
  add_friend: {
    required: ["target_user_id", "source_flow"],
    optional: ["user_id"],
  },
  send_message: {
    required: ["channel", "char_count"],
    optional: ["user_id", "target_user_id"],
  },
  view_game: {
    required: ["game_id", "source_flow"],
    optional: ["game_name", "user_id"],
  },
  add_review: {
    required: ["game_id", "has_text"],
    optional: ["user_id", "rating_stars", "contains_spoilers"],
  },
  session_log: {
    required: ["game_id", "duration_hours", "platform"],
    optional: ["user_id", "game_name", "visibility", "source"],
  },
  onboarding_started: {
    required: [],
    optional: ["user_id", "path"],
  },
  steam_connected: {
    required: ["result"],
    optional: ["user_id", "games_imported"],
  },
  first_session_created: {
    required: ["game_id"],
    optional: ["user_id", "game_name", "duration_hours", "platform"],
  },
  onboarding_completed: {
    required: ["path"],
    optional: ["user_id", "platforms_count", "genres_count", "games_count", "has_steam"],
  },
});

export const BUSINESS_EVENT_CONTRACT = Object.freeze({
  category: "business",
  schemaVersion: analyticsConfig.eventSchemaVersion,
  names: BUSINESS_EVENT_NAMES,
});
